export const DSA_REVIEW_CHECK = "DSA_REVIEW_CHECK";
export const DSA_REVIEW_DISMISS = "DSA_REVIEW_DISMISS";
export const DSA_REVIEWED_SET = "DSA_REVIEWED_SET";
export const DSA_MISSING_INFO_SHOW = "DSA_MISSING_INFO_SHOW";
export const DSA_MISSING_INFO_DISMISS = "DSA_MISSING_INFO_DISMISS";